export default __webpack_public_path__ + "static/media/dapp-img.6ef64bf0.gif";